import { getDecodedShopifyProductIdString } from "@utils/index"
import React from "react"

const MAESTRA_LOGIN = "maestra_authorize"
const MAESTRA_VIEW_CATEGORY = "maestra_view_category"
const MAESTRA_VIEW_PRODUCT = "maestra_view_product"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MAESTRA_SET_CART = "maestra_set_cart" // Fired in Redux, keep for reference

export interface MaestraProduct {
  price: string
  productId: string
  quantity: number
}

export interface MaestraUser {
  email: string
}

const getDataLayer = (): any[] | undefined => {
  if (typeof window === "undefined") {
    return undefined
  }

  const w = window as any
  w.dataLayer = w.dataLayer || []
  return w.dataLayer
}

export default () => {
  const dataLayer = getDataLayer()

  const maestraOnLogin = React.useCallback(
    (user: MaestraUser) => {
      if (dataLayer) {
        dataLayer.push({
          customerEmail: user.email,
          event: MAESTRA_LOGIN,
        })
      }
    },
    [dataLayer]
  )

  const maestraOnViewCategory = React.useCallback(
    ({ category, user }: { category: string; user: MaestraUser }) => {
      if (dataLayer) {
        dataLayer.push({
          categoryId: category,
          customerEmail: user.email,
          event: MAESTRA_VIEW_CATEGORY,
        })
      }
    },
    [dataLayer]
  )

  const maestraOnViewProduct = React.useCallback(
    ({ product, user }: { product: string; user: MaestraUser }) => {
      if (dataLayer) {
        const productId = getDecodedShopifyProductIdString(product)

        dataLayer.push({
          customerEmail: user.email,
          event: MAESTRA_VIEW_PRODUCT,
          productId,
        })
      }
    },
    [dataLayer]
  )

  return {
    maestraOnLogin,
    maestraOnViewCategory,
    maestraOnViewProduct,
  }
}
